module.exports = __webpack_public_path__ + "static/media/lrg_icon.9874b2fb.ico";